import type { ReactNode } from "react";
import { ConfirmProvider } from "./Confirm";
import { GfPortalProvider } from "./Portal";
import { ToastProvider } from "./Toast";

export interface GfProviderProps {
  children: ReactNode;
  /**
   * Where floating UI renders. Omit in the portal (document.body). In the
   * extension overlay pass an element inside the shadow root.
   */
  portalContainer?: Element | DocumentFragment | null;
}

/** Toasts + confirm dialogs + portal target, in one wrapper. Mount once near the root. */
export function GfProvider({ children, portalContainer = null }: GfProviderProps) {
  return (
    <GfPortalProvider container={portalContainer}>
      <ToastProvider>
        <ConfirmProvider>{children}</ConfirmProvider>
      </ToastProvider>
    </GfPortalProvider>
  );
}
